<template>
    <div v-if="$store.state.isModalOpenTwo" class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-lg modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                          <h1 class="mb-0">Loan Statement</h1>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                  <div class="row mx-2">
                    <div class="table-responsive" style="min-height: 400px;">
                      <table class="table table-bordered">
                        <thead>
                        <tr>
                          <th>Pay Head</th>
                          <th>Date</th>
                          <th>Amount</th>
                        </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, i) in loanStatementData" :key="i">
                             <td>{{ item.pay_head_name }}</td>
                             <td>{{ item.created_date }}</td>
                             <td>{{ item.amount }}</td>
                           </tr>
                        </tbody>
                      </table>
                    </div>

                    </div>
                 </div>
            </div>
        </div>
        <Loader v-if="loader"/>

    </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import { ref } from "vue";
import { useStore } from "vuex";

const props = defineProps({
  loanStatementData:{
    type:Object,
    default:[]
  },
});
const $store = useStore();
const modalRef = ref(null);
const loader = ref(false);

const onClickClose = () => {
    $store.state.isModalOpenTwo = false;
}

</script>
